<template>
  <b-container>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />
    <b-modal ref="openModal" class="localizationModal" scrollable size="ml" title="Adicionar Novo Ponto de Parada"
      @hide="hideModal">
      <b-form-group :label="$t('workflow.waypoint.waypointDocumentNumberLabel')" label-for="cnpj-input" calss="mb-4">
        <b-form-input id="cnpj-form" type="text" required v-model="model.companyDocumentNumber"
          :placeholder="$t('workflow.waypoint.waypointDocumentNumberLabel')"></b-form-input>
      </b-form-group>

      <!-- <div>Model WaypointModal : {{ model }}</div> -->
      <!-- point {{ point }} -->

      <b-form-group :label="$t('workflow.waypoint.waypointName')" label-for="input-waypoint-name" class="mb-4">
        <b-form-input id="input-form-name" type="text" v-model="model.name" required
          :placeholder="$t('workflow.waypoint.waypointName')">
        </b-form-input>
      </b-form-group>

      <b-form-group :label="$t('workflow.waypoint.waypointFullAddress')" label-for="input-waypoint-fullAddress"
        class="mb-4">
        <b-form-input id="input-form-name" type="text" v-model="model.fullAddress" required
          :placeholder="$t('workflow.waypoint.waypointFullAddress')">
        </b-form-input>
      </b-form-group>

      <div v-if="mapEngine === '0'">
        <leaflet-marker-crud :model.sync="markerCrud" :id="'map2'" />
      </div>

      <div v-if="mapEngine === '1'">
        <google-map-marker-crud :model.sync="markerCrud" :id="'map2'" />
      </div>

      <!-- markerCrud: {{ markerCrud }} -->
      <!-- {{ model }} -->

      <template #modal-footer="{}">
        <div class="right">
          <b-button variant="green" @click="save" :disabled="submitted">
            {{ $t("geral.confirm") }}
          </b-button>
          <b-button class="ml-2" variant="danger" @click="remove()">Romever</b-button>
        </div>
      </template>
    </b-modal>
  </b-container>
</template>
<script>
export default {
  name: "WaypointModal",
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    // LeafletMarkerCrud: () =>
    //   import("@/components_rms/base/leaflet/crud/LeafletMarkerCrud.vue"),
    GoogleMapMarkerCrud: () =>
      import("@/components_rms/base/googlemaps/crud/GoogleMapMarkerCrud.vue")
  },
  props: {
    point: Object,
    waypointSelected: Object,
    canEdit: Boolean
  },
  data() {
    return {
      mapEngine: localStorage.getItem("mapEngine"),
      alert: {
        error: "",
        success: "Registro alterado com sucesso"
      },
      submitted: false,
      model: {
        id: 0,
        name: "",
        companyDocumentNumber: "",
        fullAddress: "",
        latitude: 0.0,
        longitude: 0.0,
        active: false
      },
      markerCrud: {
        fullAddress: "",
        latitude: 0.0,
        longitude: 0.0
      }
    };
  },
  methods: {
    show(point) {
      // console.log("WaypointModalEdit")
      // console.log(point)
      if (point) {
        this.model.id = this.point.id;
        this.model.companyDocumentNumber = point.companyDocumentNumber
        this.model.name = point.name;
        this.model.fullAddress = point.fullAddress;
        this.model.latitude = point.latitude;
        this.model.longitude = point.longitude;
        this.model.active = point.active;
        // console.log(this.point)
        this.markerCrud = {
          latitude: point.latitude,
          longitude: point.longitude,
          fullAddress: point.fullAddress
        };
      }
      this.$refs.openModal.show();
    },
    save() {
      this.submitted = true;
      this.model.latitude = this.markerCrud.latitude;
      this.model.longitude = this.markerCrud.longitude;
      this.model.companyDocumentNumber = this.model.companyDocumentNumber;
      this.model.fullAddress = this.markerCrud.fullAddress;
      this.$apiWorkflow.post("/waypoint/save/", this.model).then(response => {
        this.$refs.alert.show();
        this.submitted = false;
        this.$emit("update:point", this.model);
        this.$forceUpdate();
        this.hideModal();
        this.$refs.openModal.hide();
      });
    },
    remove() {
      this.$apiWorkflow
        .post("/waypoint/desactive/" + this.model.id)
        .then(response => {
          this.$refs.alert.show();
          this.submitted = false;
          this.model = response.data;
          let waypoint = {
            value: 0,
            text: ""
          };
          let edit = false;
          this.$emit("update:canEdit", edit);
          this.$emit("update:point", this.model);
          this.$emit("update:waypointSelected", waypoint);
          this.$forceUpdate();
          this.hideModal();
          this.$refs.openModal.hide();
        });
    },
    hideModal() {
      this.model = {
        id: 0,
        name: "",
        companyDocumentNumber: "",
        fullAddress: "",
        latitude: 0.0,
        longitude: 0.0,
        active: false
      };
    }
  }
};
</script>
<style scoped>
.right {
  text-align: right;
  width: 100%;
}
</style>
